import $ from "jquery";

$(function() {

    initTabbedText();

});

function initTabbedText() {

    $('.tabs > ul > li').unbind('click');
    $('.tabs > ul > li').on('click', function() {

        // Set the tab header class
        let $tabbedText = $(this).closest('.tabbedtext').first();
        let $tabHeaderUl = $(this).parent();
        $tabHeaderUl.find('> li').removeClass('active');
        $(this).addClass("active");

        // Show the selected tab content
        let sectionId = $(this).attr('data-section');
        $tabbedText.find('.tabbedcontent').hide();
        $tabbedText.find('.' + sectionId).fadeIn();

    });

    $('.faqq h4').unbind('click');
    $('.faqq h4').on('click', function() {
        $(this).closest('.faqq').next('.faqa').toggleClass('open').slideToggle(200);
        $(this).toggleClass('open');
        return false;
    });

}


